export const openWhatsApp = (phone, message = '') => {
  if (typeof window === 'undefined') return;
  const sanitizedPhone = (phone || '').replace(/\D/g, '');
  const url = `https://wa.me/${sanitizedPhone}?text=${encodeURIComponent(message || '')}`;
  window.open(url, '_blank', 'noopener,noreferrer');
};
export default openWhatsApp;